import redemptionsService from "@irati/checkout/services/redemptions"
import {HelixOrderProductShipped} from "@irati/types"
import theme from "@irati/ui/src/global/theme"
import Loading from "@irati/ui/src/Loading"
import {Body} from "@irati/ui/src/Typography"
import FormattedMessage from "@irati/utils/lang"
import {hangPromise} from "@irati/utils/promise"
import React, {useEffect, useState} from "react"

type Props = {
  redemptionId: string
}

type ShippingStatus = Pick<HelixOrderProductShipped, "trackingNumber" | "trackingProviderName"> & {
  isCanceled: boolean
}

const MerchandiseStatus = ({redemptionId}: Props) => {
  const [load, setLoad] = useState<Promise<any>>(hangPromise)
  const [shippingStatus, setShippingStatus] = useState<ShippingStatus>()

  const getShippingStatus = async () => {
    const promise = redemptionsService.getMerchandiseStatus(redemptionId!)

    setLoad(promise)

    const statusRes = await promise

    setShippingStatus({
      isCanceled: statusRes.action === "product.canceled",
      ...statusRes.data
    })
  }

  useEffect(() => {
    getShippingStatus()
  }, [redemptionId])

  const spacing = theme.spacing.one

  const PendingStatus = () => (
    <Body small weight="bold" marginTop={spacing}>
      <FormattedMessage id="perks.components.myPerks.merchSummary.trackingInfo.pending" />
    </Body>
  )

  return (
    <Loading load={load} Error={PendingStatus}>
      <Body small weight="bold" marginTop={spacing}>
        <FormattedMessage id="perks.components.myPerks.merchSummary.trackingInfo.deliveryProvider" />
      </Body>
      <Body small>{shippingStatus?.trackingProviderName}</Body>
      <Body small weight="bold" marginTop={spacing}>
        <FormattedMessage id="perks.components.myPerks.merchSummary.trackingInfo.trackingNumber" />
      </Body>
      <Body small>#{shippingStatus?.trackingNumber}</Body>
    </Loading>
  )
}

export default MerchandiseStatus
